import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { CommonClient } from "../../../store/repsaApi";

const client = new CommonClient(app_uri, axiosClient());

export default client;
